/**
 * Notifications Screen
 * 
 * Loads the UserPreferences MFE with /notifications path for notification settings.
 * 
 * @module components/menu/NotificationsScreen
 */

import React from 'react';
import { MFELoader } from '@/components/mfe/MFELoader';
import { useAuth } from '@/contexts/AuthContext';
import { CommunicationBridge } from '@sequelae/lore-mfe-kit';

export const NotificationsScreen: React.FC = () => {
  const { user, logout } = useAuth();
  const token = CommunicationBridge.getAccessToken();

  if (!token || !user) {
    return <div>Unauthorized</div>;
  }

  return (
    <MFELoader
      mfeName="UserPreferences"
      accessToken={token}
      refUserId={user.id}
      onLogout={logout}
      initialPath="/notifications"
      onError={(err) => {
        console.error('[NotificationsScreen] MFE Load Error:', err);
      }}
    />
  );
};

